import Column from '@components/Column';
import Description from '@components/Description';
import Row from '@components/Row';
import Text from '@components/Text';
import colors from '@constants/colors';
import useProject from '@hooks/useProject';
import useRewardPolicies from '@hooks/useRewardPolicies';
import { useTranslation } from 'react-i18next';

import useAssets from './hooks/useAssets';

function DisposeDescription() {
    const { t } = useTranslation('accountTermination');
    const { data } = useAssets();
    const { stampEnabled, pointEnabled } = useRewardPolicies();
    const project = useProject();

    return (
        <Description>
            <Column fullWidth spacing={1.5}>
                {project?.features.ppCardEnabled && (
                    <DisposeRow label={t('dispose.prepaidCardBalance')}
                        value={`${data?.prepaidCardBalance?.toLocaleString() || 0}${t('dispose.won')}`} />
                )}
                {stampEnabled && (
                    <DisposeRow label={t('dispose.stamp')}
                        value={`${data?.totalStampCount?.toLocaleString() || 0}${t('dispose.count')}`} />
                )}
                {pointEnabled && (
                    <DisposeRow label={t('dispose.point')}
                        value={`${data?.totalPoint?.toLocaleString() || 0}${t('dispose.won')}`} />
                )}
                <DisposeRow label={t('dispose.coupon')}
                    value={`${data?.totalCouponCount?.toLocaleString() || 0}${t('dispose.count')}`} />
            </Column>
        </Description>
    );
}

interface RowProps {
    label: string;
    value: string;
}

function DisposeRow({ label, value }:RowProps) {
    return (
        <Row fullWidth
            justify='space-between' >
            <Text color={colors.gray6}>{label}</Text>
            <Text
                color={colors.gray7}
                fontWeight='bold' >
                {value}
            </Text>
        </Row>
    );
}

export default DisposeDescription;
